module.exports = __webpack_public_path__ + "static/media/pic_basic_business_plan.0549e402.jpg";